







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PaginationDisplay extends Vue {
  @Prop() page!: number;

  @Prop() size!: number;

  @Prop() totalWorkItems!: number;

  get startItem() {
    return (this.page - 1) * this.size + 1;
  }

  get endItem() {
    return Math.min(this.page * this.size, this.totalWorkItems);
  }
}
